import React, { useState } from 'react';
import classNames from 'classnames';
import { ReactComponent as Home } from 'Icons/home.svg';
import { ReactComponent as Order } from 'Icons/order.svg';
import { isDesmetSupplier } from 'Utils/index';


const sidePanel = [
    {label: 'Overview', icon: <Home />, id: 1},
    {label: 'My Orders', icon: <Order />, id: 2},
    {label: 'Transportation Requests', icon: <Order />, id: 3},
    {label: 'Report', icon: <Order />, id: 4, subMenu: [
        {label: 'Purchase Orders Report', path: '/report/221'}
    ]},
]

const SidePanel = (props) => {
    const isSupplier = isDesmetSupplier();
    const [isReportOpen, setIsReportOpen] = useState(false);
    return (
        <div className={'sidePanel'}>
            {(sidePanel || []).map(el => {
                if(!isSupplier && el.id == 3) {
                    return false;
                }
                if(isSupplier && el.id == 1) {
                    return false;
                }
                if(el.subMenu) {
                    return (
                        <div key={el.id} className={'col-1'}>
                            <div
                                className={classNames("sideList curP", {
                                    'active': isReportOpen
                                })}
                                onClick={() => setIsReportOpen(!isReportOpen)}
                            >
                                <div className="sideLabel">
                                    {el.icon}
                                    <div>{el.label}</div>
                                </div>
                            </div>
                            {isReportOpen && <div className={'subSideList'}>
                                {el.subMenu.map(sub => (
                                    <div key={sub.label}
                                        className={'subSideItem curP'}
                                        onClick={() => props.onClickReport(sub)}>
                                        {sub.label}
                                    </div>
                                ))}
                            </div>}
                        </div>
                    )
                }
                return (<div key={el.id}
                    className={classNames("sideList curP", {
                        'active': props.selectedTab == el.id
                    })} onClick={() => props.onClickTab(el)}>
                    <div className="sideLabel">
                        {el.icon}
                        <div>{el.label}</div>
                    </div>
                </div>)
            })}
        </div>
    )
}

export default SidePanel
